export default "__VITE_ASSET__CohPbVjn__"